export default "__VITE_ASSET__3HZZdFPc__"